angular.module('env.data.httpInterceptors.requestRepeaterInterceptor', [])

    .factory('requestRepeaterInterceptor', function ($q, $injector, $timeout) {
        // To avoid circular dependency we use $injector
        var services = {};

        function getService(serviceName) {
            if (services[serviceName]) {
                return services[serviceName];
            }
            services[serviceName] = $injector.get(serviceName, "requestRepeaterInterceptor");
            return services[serviceName];
        }

        /**
         * HTTP response codes for server unavailability detection
         * @type {number[]}
         */
        var serverUnavailableCodes = [
            403, 404, 405, 406, 407, 408, 409, 410, 429, 434,
            501, 502, 503, 504, 509,
            0
        ];

        /**
         * HTTP response codes for unAuthorised detection
         * @type {number[]}
         */
        var unAuthorisedCodes = [
            401
        ];

        /**
         * Ignored URLs
         * @type {string[]}
         */
        var ignoredUrls = [
            om.config.build.baseUrl + "/ping",
            om.config.build.baseUrl + "/auth/logout",
            om.config.build.baseUrl + "/auth/login"
        ];

        var reAuthPromise;
        var reConnectPromise;

        /**
         * ReAuthorise promise
         * @param {Object} response $http response object
         * @returns {Promise}
         */
        function reAuth(response) {
            if (!reAuthPromise) {
                if (getService('$state').is('login')) {
                    return $q.reject(response);
                }

                reAuthPromise = getService("authService").reAuth();
            }

            return reAuthPromise.then(
                function () {
                    reAuthPromise = null;
                    return getService("$http")(response.config);
                },
                function () {
                    reAuthPromise = null;
                });
        }

        /**
         * ReConnect promise
         * @param {Object} response $http response object
         * @returns {Promise}
         */
        function reConnect(response) {
            if (!reConnectPromise) {
                reConnectPromise = getService("pingService").ping()
                    .then(
                        function () {
                            reConnectPromise = null;
                            return $q.reject(response);
                        },
                        function () {
                            return getService("pingService").blockTillConnected();
                        }
                    );
            }

            return reConnectPromise.then(
                function () {
                    reConnectPromise = null;
                    return $timeout(function () {
                        return getService("$http")(response.config);
                    }, 200);
                },
                function () { // impossible!
                    reConnectPromise = null;
                    return $q.reject(response);
                });
        }

        return {
            'responseError': function (response) {
                if (response && response.config && response.config.url && !_.contains(ignoredUrls, response.config.url)) {
                    if (_.contains(unAuthorisedCodes, response.status)) {
                        return reAuth(response);
                    }
                    if (_.contains(serverUnavailableCodes, response.status)) {
                        return reConnect(response);
                    }
                }

                return $q.reject(response);
            }
        };
    })

;
